
namespace RedBullMOBILE360.Administration {

    @Serenity.Decorators.registerClass()
    export class DbLinkMapGrid extends Serenity.EntityGrid<DbLinkMapRow, any> {
        protected getColumnsKey() { return DbLinkMapColumns.columnsKey; }
        protected getDialogType() { return DbLinkMapDialog; }
        protected getIdProperty() { return DbLinkMapRow.idProperty; }
        protected getInsertPermission() { return DbLinkMapRow.insertPermission; }
        protected getLocalTextPrefix() { return DbLinkMapRow.localTextPrefix; }
        protected getService() { return DbLinkMapService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}